import * as amplitude from "@amplitude/analytics-browser";

export const initAmplitude = () => {
  amplitude.init("1748d420817939133fbb2ddaab4798bb");
};

export const trackEvent = (eventName, eventProperties = {}) => {
  amplitude.track(eventName, eventProperties);
};
